<template>
	<div class="logo-title">
		<span @click="toPc">
			<svg-icon class-name="logo" icon-class="logo"></svg-icon>
		</span>
		<div class="title" @click="routeToHome">创作中心</div>
	</div>
</template>

<script>
export default {
	name: 'LogoTitle',
	data() {
		return {}
	},
	methods: {
		toPc() {
			location.href = 'https://www.kuaikanmanhua.com/';
		},
		routeToHome() {
			this.$router.push({ path: '/' })
		}
	}
}
</script>

<style lang="scss" scoped>
.logo-title {
	overflow: hidden;
	cursor: pointer;
	&:hover .title {
		color: $yellow;
	}
}
.logo {
	display: block;
	margin-right: 15px;
	font-size: 64px;
	color: $yellow;
	float: left;
}
.title {
	font-size: 18px;
	font-weight: bold;
	float: left;
	line-height: 64px;
	color: $white;
	&::before {
		content: '';
		display: block;
		float: left;
		width: 1px;
		height: 15px;
		background-color: rgba(255, 255, 255, 0.3);
		margin: 25px 15px 0 0;
	}
}
</style>
